export namespace RouterOutlets {	export const rightPanel = 'right-panel';	export const modalDialog = 'modal-dialog';}